import FruskacCrni from '../assets/fruvin-fruskac-crni.png';
import FruskacBeli from '../assets/fruvin-fruskac-beli.png';
import FruskacRose from '../assets/fruvin-fruskac-rose.png';
import FruskacCrni2L from '../assets/fruvin-fruskac-crni-2l.png';
import FruskacBeli2L from '../assets/fruvin-fruskac-beli-2l.png';
import FruskacRose2L from '../assets/fruvin-fruskac-rose-2l.png';
import WineListPage from '../components/molecules/WineListPage/WineListPage';
import BackgroundImage from '../assets/fruvin-fruskac-bg.jpeg';
import FruskacLogo from '../assets/fruvin-fruskac.svg';
import { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Helmet } from 'react-helmet-async';
import SeoLinks from '../components/atoms/Seo/SeoLinks';

const Fruskac = () => {
    const intl = useIntl();

    useEffect(() => {
        window.scrollTo(0, 0);
    },[]);

    const wines = [
        {
            id: 9,
            image: FruskacCrni,
            name: <FormattedMessage id='fruskac__red_name' defaultMessage="Missing translation value" />,
            description: <FormattedMessage id='fruskac__red_description' defaultMessage="Missing translation value" />,
            liter: <FormattedMessage id='fruskac__red_liter' defaultMessage="Missing translation value" />,
            urlName: 'crveni-fruskac',
            metaTitleId: 'fruskac__red_name',
            metaDescriptionId: 'fruskac__red_meta_description'
        },
        {
            id: 10,
            image: FruskacBeli,
            name: <FormattedMessage id='fruskac__white_name' defaultMessage="Missing translation value" />,
            description: <FormattedMessage id='fruskac__white_description' defaultMessage="Missing translation value" />,
            liter: <FormattedMessage id='fruskac__white_liter' defaultMessage="Missing translation value" />,
            urlName: 'beli-fruskac',
            metaTitleId: 'fruskac__white_name',
            metaDescriptionId: 'fruskac__white_meta_description'
        },
        {
            id: 11,
            image: FruskacRose,
            name: <FormattedMessage id='fruskac__rose_name' defaultMessage="Missing translation value" />,
            description: <FormattedMessage id='fruskac__rose_description' defaultMessage="Missing translation value" />,
            liter: <FormattedMessage id='fruskac__rose_liter' defaultMessage="Missing translation value" />,
            urlName: 'roze-fruskac',
            metaTitleId: 'fruskac__rose_name',
            metaDescriptionId: 'fruskac__rose_meta_description'
        },
        {
            id: 12,
            image: FruskacCrni2L,
            name: <FormattedMessage id='fruskac__red_2l_name' defaultMessage="Missing translation value" />,
            description: <FormattedMessage id='fruskac__red_2l_description' defaultMessage="Missing translation value" />,
            liter: <FormattedMessage id='fruskac__red_2l_liter' defaultMessage="Missing translation value" />,
            urlName: 'crveni-fruskac-2l',
            metaTitleId: 'fruskac__red_2l_name',
            metaDescriptionId: 'fruskac__red_2l_meta_description'
        },
        {
            id: 13,
            image: FruskacBeli2L,
            name: <FormattedMessage id='fruskac__white_2l_name' defaultMessage="Missing translation value" />,
            description: <FormattedMessage id='fruskac__white_2l_description' defaultMessage="Missing translation value" />,
            liter: <FormattedMessage id='fruskac__white_2l_liter' defaultMessage="Missing translation value" />,
            urlName: 'beli-fruskac-2l',
            metaTitleId: 'fruskac__white_2l_name',
            metaDescriptionId: 'fruskac__white_2l_meta_description'
        },
        {
            id: 14,
            image: FruskacRose2L,
            name: <FormattedMessage id='fruskac__rose_2l_name' defaultMessage="Missing translation value" />,
            description: <FormattedMessage id='fruskac__rose_2l_description' defaultMessage="Missing translation value" />,
            liter: <FormattedMessage id='fruskac__rose_2l_liter' defaultMessage="Missing translation value" />,
            urlName: 'roze-fruskac-2l',
            metaTitleId: 'fruskac__rose_2l_name',
            metaDescriptionId: 'fruskac__rose_2l_meta_description'
        }
    ];

    return (
        <>
            <Helmet>
                <title>
                    {intl.formatMessage({
                        id: 'navigation__fruskac',
                        defaultMessage: 'Fruškać',
                    })} | Fruskogorski vinogradi
                </title>
                <meta name="description" content={
                        intl.formatMessage({
                        id: 'fruskac__meta_description',
                        defaultMessage: 'Otkrijte Fruškać vina iz vinarije Fruškogorski vinogradi na Fruškoj gori. Birajte između belih, crvenih i roze vina, idealnih za svakodnevne prilike, koja donose svežinu i vrhunski kvalitet po pristupačnim cenama.',
                    })} />
            </Helmet>
            <SeoLinks />
            <WineListPage
                type={'fruskac'}
                backgroundImage={BackgroundImage}
                descriptionText={intl.formatMessage({ id: 'fruskac__description', defaultMessage: 'Missing translation' })}
                wineLogo={FruskacLogo}
                wines={wines}
            />
        </>
    );
}

export default Fruskac;
